module.exports = __webpack_public_path__ + "static/media/53_hot_topics_shortcut.fef694a7.png";